.root {
  --tooltip--background: var(--theme--color--mono--black);
  --tooltip--text-color: var(--theme--color--mono--white);

  box-sizing: border-box;
  font-size: 0.875rem;
  line-height: 1.25rem;
  display: flex;
  flex-direction: column;
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  background-color: var(--tooltip--background);
  color: var(--tooltip--text-color);
  transform-origin: var(--transform-origin);
  z-index: var(--theme--index--layer--popup);
  transition: transform 150ms,
  opacity 150ms;

  &[data-starting-style],
  &[data-ending-style] {
    opacity: 0;
    transform: scale(0.9);
  }

  &[data-instant] {
    transition-duration: 0ms;
  }

  outline: 1px solid var(--tooltip--background);
  box-shadow: 0 10px 15px -3px var(--tooltip--background),
  0 4px 6px -4px var(--tooltip--background);

  .arrow {
    fill: var(--tooltip--background);
  }
}